import { getLuminance, parseToRgb } from 'polished';

// The browser color-scheme for form inputs follows the luminance of the
// input's own themed background, not the page's color mode: a light-mode
// theme can still have dark inputs and vice versa, and the UA renders
// autofill highlights, select dropdowns and pickers against the input
// surface. Semi-transparent or unparseable values (var() chains) fall back
// to the mode, whose default input surface always agrees with it.
export default function getInputColorScheme(backgroundColor, colorMode) {
  if (backgroundColor) {
    try {
      const rgb = parseToRgb(backgroundColor);
      const alpha = 'alpha' in rgb ? rgb.alpha : 1;
      if (alpha >= 0.5) {
        // 0.179 is the W3C readable-color luminance threshold
        return getLuminance(backgroundColor) > 0.179 ? 'light' : 'dark';
      }
    } catch (e) {
      // fall through to the mode
    }
  }
  return colorMode === 'dark' ? 'dark' : 'light';
}
